import reduceReducers from 'reduce-reducers';
import {
  SET_FULFILLMENT_OPTIONS,
  RESET_FULFILLMENT_OPTIONS,
  RESET_SHIPPING_ADDRESS
} from 'base/actions/actionTypes';
import { getIsAsapAvailableForLocationAndMethodSelector } from 'locations/selectors/';

import { directlyEditableCartFields } from 'cart/reducers';
import {
  areFulfillmentOptionSetSelector,
  areFulfillmentDeliveryOptionsSetSelector,
  getAsapLabelSelector
} from 'cart/selectors';
import { fulfillmentOptions } from 'cart/constants/fulfillmentOptions';
import validateAddressFactory, {
  validatingAddressInitialState
} from 'base/reducers/validateAddressFactory';

export const initialState = {
  ...directlyEditableCartFields,
  ...validatingAddressInitialState
};

const fulfillmentOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FULFILLMENT_OPTIONS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case RESET_FULFILLMENT_OPTIONS: {
      return initialState;
    }
    case RESET_SHIPPING_ADDRESS: {
      return {
        ...state,
        shipping_street_address_1: '',
        shipping_street_address_2: '',
        shipping_city: '',
        shipping_state: '',
        shipping_postal_code: '',
        shipping_country: '',
        shipping_google_place_id: ''
      };
    }
    default: {
      return state;
    }
  }
};

const cartWorkingCopy = reduceReducers(
  fulfillmentOptionsReducer,
  validateAddressFactory('cart')
);

export default cartWorkingCopy;

/* === SELECTORS === */

export const isDinerAddressDeliverableSelector = cartWorkingCopy => {
  return cartWorkingCopy.shipping_google_place_id
    ? cartWorkingCopy.has_online_ordering_delivery_zone ||
        cartWorkingCopy.is_within_doordash_radius
    : null;
};

/* if it's delivery, is there an address and is the address valid */
export const areFulfillmentOptionsValidSelector = ({
  cartWorkingCopyState
}) => {
  const isDinerAddressDeliverable = isDinerAddressDeliverableSelector(
    cartWorkingCopyState
  );

  const areFulfillmentDateTimeOptionsSet = areFulfillmentOptionSetSelector(
    cartWorkingCopyState
  );

  const fulfillmentDeliveryOptionsAreSet = areFulfillmentDeliveryOptionsSetSelector(
    cartWorkingCopyState
  );
  const areFulfillmentDeliveryOptionsValid =
    cartWorkingCopyState.online_ordering_fulfillment_method ===
    fulfillmentOptions.DELIVERY
      ? isDinerAddressDeliverable && fulfillmentDeliveryOptionsAreSet
      : true;

  const areFulfillmentOptionsValid =
    areFulfillmentDateTimeOptionsSet && areFulfillmentDeliveryOptionsValid;

  return !!areFulfillmentOptionsValid;
};

export const getAsapLaterOptionsSelector = (
  restaurantLocations,
  locationThrottledTimes,
  cartWorkingCopy
) => {
  const isAsapAvailableForLocationAndMethod = getIsAsapAvailableForLocationAndMethodSelector(
    {
      restaurantLocationsState: restaurantLocations,
      locationThrottledTimesState: locationThrottledTimes,
      cart: cartWorkingCopy,
      selectedMethod: cartWorkingCopy.online_ordering_fulfillment_method,
      onlineOrderingLocation: cartWorkingCopy.online_ordering_location
    }
  );

  const asapLabel = getAsapLabelSelector({
    locationThrottledTimes,
    restaurantLocations,
    cart: cartWorkingCopy
  });

  return [
    {
      value: 1,
      disabled: !isAsapAvailableForLocationAndMethod,
      label: isAsapAvailableForLocationAndMethod
        ? asapLabel
        : 'ASAP (Currently Unavailable)'
    },
    { value: 0, label: 'Later' }
  ];
};
